import { useGetUserDataQuery } from 'api/accountEndpoints';
import { useSelector } from 'react-redux';
import { getToken } from 'store/selectors/authSelectors';

const useGetUser = () => {
    const token = useSelector(getToken);
    const { data } = useGetUserDataQuery(undefined, { skip: !token });

    return data;
};

export default useGetUser;
